import { useConst } from "@fluentui/react-hooks";
import { useEffect, useMemo, useState } from "react";

// Credit : Mateusz Rybczonec
// https://css-tricks.com/how-to-create-an-animated-countdown-timer-with-html-css-and-javascript/

const Countdown = (props) => {

    const {
        onZero = () => null,
    } = props;

    const FULL_DASH_ARRAY = useConst(283);
    const TIME_LIMIT = useConst(5);

    const [timeLeft, setTimeLeft] = useState(TIME_LIMIT);

    const timerInterval = setInterval(() => {
        setTimeLeft(prev => prev - 1);
    }, 1000);

    useEffect(() => {
        if (timeLeft <= 0) {
            onZero();
            clearInterval(timerInterval);
        }
    }, [onZero, timeLeft, timerInterval]);

    useEffect(() => {
        return () => clearInterval(timerInterval);
    });

    const strokeDasharray = useMemo(() => {
        const rawTimeFraction = timeLeft / TIME_LIMIT;
        const timeFraction = rawTimeFraction - (1 / TIME_LIMIT) * (1 - rawTimeFraction);
        return `${(timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    }, [FULL_DASH_ARRAY, TIME_LIMIT, timeLeft]);

    const styles = useMemo(() => {
        return {
            circle: {
                fill: "none",
                stroke: "none",
            },
            elapsed: {
                stroke: "grey",
                strokeWidth: 7,
            },
            remaining: {
                color: "red",
                fillRule: "nonzero",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeWidth: 7,
                transform: "rotate(90deg)",
                transformOrigin: "center",
                transition: "1s linear all",
            },
            root: {
                height: 20,
                position: "relative",
                width: 20,
            },
            svg: { transform: "scaleX(-1)" },
        };
    }, []);

    return <div style={styles.root}>
        <svg style={styles.svg} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <g style={styles.circle}>
                <circle style={styles.elapsed} cx="50" cy="50" r="45" />
                <path
                    strokeDasharray={strokeDasharray}
                    style={styles.remaining}
                    d="
                      M 50, 50
                      m -45, 0
                      a 45,45 0 1,0 90,0
                      a 45,45 0 1,0 -90,0
                    "
                />
            </g>
        </svg>
    </div>;

};

export default Countdown;